import React, {useEffect} from 'react'
import questionsApi from '../../../../../services/api/questionLibrary/questionsApi'
import Snackbar from '@mui/material/Snackbar'

import {
  Backdrop,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  Chip,
  Alert,
  TextField,
} from '@mui/material'
import {
  AddCircleOutline,
  ArrowRight,
  RemoveCircleOutline,
} from '@mui/icons-material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import surveyQuestionApi from '../../../../../services/api/surveys/surveyQuestionApi'
import WbButton from '../../../../../components/common/WbButton'
import {AUDIENCE, QUESTION_TYPE} from '../../../../../utils/constants'

export default function CategoryQuestions({
  isAdmin,
  tag,
  onClose,
  survey,
  surveyQuestions,
  setSurveyQuestions,
  text,
  tagsList,
  view,
}) {
  const [questions, setQuestions] = React.useState([])
  const [selectedQuestions, setSelectedQuestions] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [showAnswers, setShowAnswers] = React.useState(0)
  const [search, setSearch] = React.useState('')
  const [showStaff, setShowStaff] = React.useState(false)
  const [showParent, setShowParent] = React.useState(false)
  const [showPupil, setShowPupil] = React.useState(false)
  const [openSnakbar, setOpenSnakbar] = React.useState(false)
  const [disableAdd, setDisableAdd] = React.useState(false)

  useEffect(() => {
    if (
      survey.audience === 1 ||
      survey.audience === 3 ||
      survey.audience === 5 ||
      survey.audience === 7
    ) {
      setShowStaff(true)
    }
    if (
      survey.audience === 2 ||
      survey.audience === 3 ||
      survey.audience === 6 ||
      survey.audience === 7
    ) {
      setShowParent(true)
    }
    if (
      survey.audience === 4 ||
      survey.audience === 5 ||
      survey.audience === 6 ||
      survey.audience === 7
    ) {
      setShowPupil(true)
    }
    setLoading(true)
    if (text === '') {
      if (view === 'library') {
        questionsApi
          .getQuestionsByTagId(tag.id, survey.audience, isAdmin)
          .then(response => loadQuestions(response))
          .finally(() => setLoading(false))
      } else {
        questionsApi
          .getSurveyQuestionsByTagId(
            survey.schoolId,
            survey.matId,
            tag.id,
            survey.audience
          )
          .then(response => loadQuestions(response))
          .finally(() => setLoading(false))
      }
    } else {
      questionsApi
        .getQuestionsByTagIdAndSearch(text, survey.audience, isAdmin, tagsList)
        .then(response => loadQuestions(response))
        .finally(() => setLoading(false))
    }
  }, [])

  const loadQuestions = response => {
    setQuestions([
      ...response.map(q => ({
        ...q,
        questionSettings: q.questionSettings ? {...q.questionSettings} : null,
        sliderResponseAttributes: q.sliderResponseAttributes
          ? {...q.sliderResponseAttributes}
          : null,
        multiOptionResponseAttributes: q.multiOptionResponseAttributes
          ? [...q.multiOptionResponseAttributes]
          : null,
        followupQuestions: q.followupQuestions
          ? [...q.followupQuestions]
          : null,
        openResponseAttributes: q.openResponseAttributes
          ? {...q.openResponseAttributes}
          : null,
      })),
    ])
  }

  const getQuestionTypeName = questionType => {
    switch (questionType) {
      case QUESTION_TYPE.LIKERT:
        return 'Likert'
      case QUESTION_TYPE.COMMENTS:
        return 'Comments'
      case QUESTION_TYPE.MULTIPLE_CHOICE:
        return 'Multi Choice'
      case QUESTION_TYPE.MULTIPLE_SELECT:
        return 'Multi Select'
      case QUESTION_TYPE.NUMBER_SLIDER:
        return 'Number Slider'
      case QUESTION_TYPE.YES_NO:
        return 'Yes No'
      case QUESTION_TYPE.YES_NO_MAYBE:
        return 'Yes No Maybe'
      case QUESTION_TYPE.PERCENTAGE:
        return 'Percentage'
      case QUESTION_TYPE.RANKING:
        return 'Ranking'
    }
  }
  const renderQuestionBlock = question => (
    <li className="questions">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack>
          <h4>
            {question.staffText !== '' && showStaff ? (
              <>
                <strong>Staff: </strong>
                {question.staffText}
              </>
            ) : null}
          </h4>
          <h4>
            {question.parentText !== '' && showParent ? (
              <>
                <strong>Parent: </strong>
                {question.parentText}
              </>
            ) : null}
          </h4>
          <h4>
            {question.pupilText !== '' && showPupil ? (
              <>
                <strong>Pupil: </strong>
                {question.pupilText}
              </>
            ) : null}
          </h4>
        </Stack>

        <div>
          {selectedQuestions.findIndex(x => x.id === question.id) === -1 ? (
            <IconButton
              disableRipple
              onClick={e => {
                if (
                  selectedQuestions.findIndex(x => {
                    return x.id === question.id
                  }) === -1
                ) {
                  setSelectedQuestions([
                    ...selectedQuestions.map(q => ({
                      ...q,
                      questionSettings: q.questionSettings,
                      sliderResponseAttributes: q.sliderResponseAttributes,
                      multiOptionResponseAttributes:
                        q.multiOptionResponseAttributes,
                      followupQuestions: q.followupQuestions,
                      openResponseAttributes: q.openResponseAttributes,
                    })),
                    {
                      ...question,
                      questionSettings: question.questionSettings,
                      sliderResponseAttributes:
                        question.sliderResponseAttributes,
                      multiOptionResponseAttributes:
                        question.multiOptionResponseAttributes,
                      followupQuestions: question.followupQuestions,
                      openResponseAttributes: question.openResponseAttributes,
                    },
                  ])
                }
              }}
            >
              <AddCircleOutline sx={{fontSize: '20px'}} />
            </IconButton>
          ) : (
            ''
          )}
        </div>
      </Stack>
      {(question.questionType === 2 ||
        (question.questionType > 3 && question.questionType < 9)) && (
        <div className="show-hide">
          <Button
            disableRipple
            onClick={e =>
              setShowAnswers(showAnswers === question.id ? 0 : question.id)
            }
            startIcon={
              showAnswers === question.id ? (
                <ArrowDropDownIcon />
              ) : (
                <ArrowRight />
              )
            }
          >
            {showAnswers === question.id ? 'Hide' : 'Show'} Answers
          </Button>

          {showAnswers === question.id ? (
            <ul className="answers">
              {question.multiOptionResponseAttributes.map(option => (
                <li>
                  {showStaff
                    ? option.staffText
                    : showParent
                      ? option.parentText
                      : option.pupilText}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      )}
      <Chip label={getQuestionTypeName(question.questionType)} size="small" />
      {/* {getQuestionTypeName(question.questionType)} */}
    </li>
  )

  const getAllQuestions = () => {
    return (
      <div className="bank-questions">
        <Grid container>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ul className="bank-question-box left-column">
              {questions
                .filter(x =>
                  search
                    ? x.staffText?.toLowerCase().includes(search.toLowerCase())
                    : true
                )
                .map((question, idx) =>
                  idx % 2 === 0 ? renderQuestionBlock(question) : null
                )}
            </ul>

            <ul className="bank-question-box right-column">
              {questions
                .filter(x =>
                  search
                    ? x.staffText?.toLowerCase().includes(search.toLowerCase())
                    : true
                )
                .map((question, idx) =>
                  idx % 2 !== 0 ? renderQuestionBlock(question) : null
                )}
            </ul>
          </Grid>
        </Grid>
      </div>
    )
  }

  const isStaffSurvey =
    survey?.audience === 1 ||
    survey?.audience === 3 ||
    survey?.audience === 5 ||
    survey?.audience === 7
  const isParentSurvey =
    survey?.audience === 2 ||
    survey?.audience === 3 ||
    survey?.audience === 6 ||
    survey?.audience === 7
  const isPupilSurvey =
    survey?.audience === 4 ||
    survey?.audience === 5 ||
    survey?.audience === 6 ||
    survey?.audience === 7

  const getSelectedQuestions = (
    selectedQuestions,
    setSelectedQuestions,
    survey,
    setSurvey
  ) => {
    return (
      <>
        <div className="selected-questions-container">
          {selectedQuestions?.map(q => {
            return (
              <div className="selected-questions">
                <div>
                  {isStaffSurvey && q.staffText
                    ? q.staffText
                    : isParentSurvey && q.parentText
                      ? q.parentText
                      : isPupilSurvey && q.pupilText
                        ? q.pupilText
                        : null}
                </div>
                <div>
                  <IconButton
                    onClick={c => {
                      setSelectedQuestions([
                        ...selectedQuestions.filter(x => x.id !== q.id),
                      ])
                    }}
                  >
                    <RemoveCircleOutline className="icon-delete" />
                  </IconButton>
                </div>
              </div>
            )
          })}
        </div>
        {selectedQuestions?.length > 0 && (
          <WbButton
            className="selected-questions-button"
            fullWidth
            onClick={e => {
              setDisableAdd(true)
              setSurveyQuestions([
                ...surveyQuestions.map(x => ({
                  ...x,
                  sliderResponseAttributes: x.sliderResponseAttributes,
                  multiOptionResponseAttributes:
                    x.multiOptionResponseAttributes,
                  followupQuestions: x.followupQuestions,
                  questionSettings: x.questionSettings,
                  openResponseAttributes: x.openResponseAttributes,
                })),
                ...selectedQuestions.map((x, pos) => ({
                  ...x,
                  order: x.order + pos + 1,
                  isEditable: false,
                  sliderResponseAttributes: x.sliderResponseAttributes,
                  multiOptionResponseAttributes:
                    x.multiOptionResponseAttributes,
                  followupQuestions: x.followupQuestions,
                  questionSettings: x.questionSettings,
                  openResponseAttributes: x.openResponseAttributes,
                })),
              ])

              let sq = []
              selectedQuestions.map((q, idx) => {
                sq.push({
                  surveyId: survey.id,
                  questionId: q.id,
                  order: surveyQuestions.length + idx - 1,
                })
              })
              if (sq.length > 0) {
                surveyQuestionApi
                  .addSurveyQuestionList(sq)
                  .then(res => {
                    setOpenSnakbar(true)
                  })
                  .catch(res => {})
                  .finally(() => {
                    setDisableAdd(false)
                    setSelectedQuestions([])
                  })
              }
            }}
            CustomButtonText={'Add ' + selectedQuestions?.length + ' Questions'}
            disabled={disableAdd || selectedQuestions?.length === 0}
          ></WbButton>
        )}
      </>
    )
  }

  return (
    <div className="question-bank-container">
      <Snackbar
        open={openSnakbar}
        anchorOrigin={{vertical: 'top', horizontal: 'right'}}
        autoHideDuration={6000}
        onClose={e => setOpenSnakbar(false)}
      >
        <Alert
          variant="filled"
          onClose={e => setOpenSnakbar(false)}
          severity="success"
          sx={{width: '100%'}}
        >
          Question added successfully!
        </Alert>
      </Snackbar>
      <Grid container>
        <Grid
          item
          lg={8}
          md={8}
          sm={12}
          xs={12}
          borderRight="1px solid #e2e2e2"
        >
          <TextField
            fullWidth
            className="search-txt"
            placeholder="Search question"
            onChange={e => setSearch(e.target.value)}
          ></TextField>

          <div className="total-questions">{questions?.length} Questions</div>
          {loading ? (
            <Backdrop open={true}>
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : questions.length > 0 ? (
            getAllQuestions()
          ) : (
            <Alert severity="info">
              There are no questions in this category.
            </Alert>
          )}
        </Grid>

        <Grid item lg={4} md={4} sm={12} xs={12} p={2}>
          <h3>Selected Questions</h3>
          <div>
            {getSelectedQuestions(
              selectedQuestions,
              setSelectedQuestions,
              survey
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  )
}
